import React from 'react';
import PropTypes from 'prop-types';

export default function IconKey({ className, style }) {
  return (
    <svg className={className} fill="none" height="15" style={style} viewBox="0 0 14 15" width="14" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.37927 6.33357C6.82511 4.7644 5.19177 3.70857 3.36594 4.07023C2.03011 4.33857 0.945107 5.40607 0.665107 6.7419C0.186774 8.9994 1.90177 11.0002 4.08344 11.0002C5.60594 11.0002 6.90094 10.0261 7.37927 8.6669H9.91677V9.83357C9.91677 10.4752 10.4418 11.0002 11.0834 11.0002C11.7251 11.0002 12.2501 10.4752 12.2501 9.83357V8.6669C12.8918 8.6669 13.4168 8.1419 13.4168 7.50023C13.4168 6.85857 12.8918 6.33357 12.2501 6.33357H7.37927ZM4.08344 8.6669C3.44177 8.6669 2.91677 8.1419 2.91677 7.50023C2.91677 6.85857 3.44177 6.33357 4.08344 6.33357C4.72511 6.33357 5.25011 6.85857 5.25011 7.50023C5.25011 8.1419 4.72511 8.6669 4.08344 8.6669Z" fill="currentColor"/>
    </svg>
  );
}

IconKey.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};
